/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

/**
 * The upstream credential an agent key uses on one MCP server.
 */
export type AgentKeyAuthClientChoice = {
  /**
   * The auth client the key uses there. Omit for a server whose upstream needs no authentication.
   */
  authClientId?: string | undefined;
  /**
   * The MCP server.
   */
  mcpServerId: string;
};

/** @internal */
export type AgentKeyAuthClientChoice$Outbound = {
  auth_client_id?: string | undefined;
  mcp_server_id: string;
};

/** @internal */
export const AgentKeyAuthClientChoice$outboundSchema: z.ZodMiniType<
  AgentKeyAuthClientChoice$Outbound,
  AgentKeyAuthClientChoice
> = z.pipe(
  z.object({
    authClientId: z.optional(z.string()),
    mcpServerId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      authClientId: "auth_client_id",
      mcpServerId: "mcp_server_id",
    });
  }),
);

export function agentKeyAuthClientChoiceToJSON(
  agentKeyAuthClientChoice: AgentKeyAuthClientChoice,
): string {
  return JSON.stringify(
    AgentKeyAuthClientChoice$outboundSchema.parse(agentKeyAuthClientChoice),
  );
}
